import React from 'react';
import PropTypes from 'prop-types';
import {COMPONENT_TYPE} from '@learningblocks/exp-constants/lib/Utilities'
import {FullWidthImage} from '@learningblocks/exp-components';
import {PlainText} from '@learningblocks/exp-components';
import {SubHeading} from '@learningblocks/exp-components';
import './style.scss';

export class TechniqueCardDescription extends React.Component {
  onScroll = () => this.setState({scrolling: true});
  renderComponent(component, key) {
    switch (component.type) {
      case COMPONENT_TYPE.FULL_WIDTH_IMAGE:
        return <FullWidthImage key={key} {...component} />;
      case COMPONENT_TYPE.PLAIN_TEXT:
        return <PlainText key={key} {...component} />;
      case COMPONENT_TYPE.SUB_HEADING:
        return <SubHeading key={key} {...component} />;
      default:
        return null;
    }
  }
  render() {
    return (
      <div className='technique-description'>
        {this.props.components.map(this.renderComponent)}
      </div>
    );
  }
}
TechniqueCardDescription.propTypes = {
  type: PropTypes.string,
  component: PropTypes.object,
};
